import { HEAVY_CLEAVE } from '../cards/attack/heavy-cleave';
import { JAB } from '../cards/attack/jab';
import { POWER_STRIKE } from '../cards/attack/power-strike';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Rare tier: 3×3, 3 dice, greedy damage-max AI.
 * Relentless two-hitter — the greedy AI funds Cleave then Power Strike, ~14
 * across a turn if the dice land. Out-block it or out-race it. */
export const RIDGEBACK_BRUTE: EnemyTemplate = {
  id: 'ridgeback-brute',
  name: 'Ridgeback Brute',
  glyph: '♉', // horned bull
  tier: 'rare',
  hp: 26,
  loadout: [
    { card: HEAVY_CLEAVE, origin: { row: 0, col: 0 }, rotated: false },
    { card: JAB, origin: { row: 0, col: 2 }, rotated: false },
    { card: POWER_STRIKE, origin: { row: 2, col: 0 }, rotated: false },
  ],
  drops: { gold: 8 },
};
